import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyNotice({
  context = 'business',
}: {
  context?: 'business' | 'guest' | 'sms' | 'payment';
}) {
  const text = {
    business:
      'AskArthur uses these details to administer your business account, onboarding and support.',
    guest:
      'The business uses your information to handle this request. AskArthur supports that service. Avoid unnecessary sensitive details.',
    sms: 'SMS permission applies only to the named sender and messages. Reading a privacy notice does not enroll you in messages.',
    payment:
      'Stripe handles the hosted payment form. AskArthur receives transaction references and payment status. Do not put card details in messages or notes.',
  };
  return (
    <p className="mt-4 text-sm leading-6 text-gray-600">
      {text[context]}{' '}
      <Link
        className="underline"
        to="/legal/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      . This notice is not consent to marketing, recording or optional tracking.
    </p>
  );
}
